export default __webpack_public_path__ + "static/media/campus2.1d520d2b.png";